import { cellActionsStyle, rowIconButtonStyle } from "@/utils/ag-grid-defaults";
import { Button } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { ColDef, ICellRendererParams } from "ag-grid-community";
import { useVendorsContext } from "../../../context/VendorsContext";

type Props = {
	setModalEditDataVendor: Function;
	setModalDeleteVendor: Function;
	setVendorIdForEdit: Function;
	setVendorIdForDelete: Function;
};
export const useTableData = ({
	setVendorIdForEdit,
	setModalEditDataVendor,
	setVendorIdForDelete,
	setModalDeleteVendor,
}: Props) => {
	const { state } = useVendorsContext();

	const columns: ColDef[] = [
		{
			field: "vendorId",
			headerName: "#",
			width: 70,
		},
		{
			field: "vendorName",
			headerName: "Name",
			minWidth: 160,
			flex: 2,
		},
		{
			field: "nsblVendorId",
			headerName: "NSBL Vendor Id",
			minWidth: 140,
			flex: 1,
		},
		{
			field: "isActive",
			headerName: "Status",
			minWidth: 110,
			flex: 1,
		},
		{
			colId: "actions",
			headerName: " ",
			sortable: false,
			filter: false,
			resizable: false,
			width: 100,
			maxWidth: 100,
			cellRenderer: (params: ICellRendererParams) => (
				<span style={cellActionsStyle}>
					<Button
						size="small"
						style={rowIconButtonStyle}
						onClick={() => {
							setVendorIdForEdit(params.data.vendorId);
							setModalEditDataVendor(true);
						}}
					>
						<EditIcon style={{ width: 18, height: 18 }} color="primary" />
					</Button>
					<Button
						size="small"
						style={rowIconButtonStyle}
						onClick={() => {
							setVendorIdForDelete(params.data.vendorId);
							setModalDeleteVendor(true);
						}}
					>
						<DeleteIcon style={{ width: 18, height: 18 }} color="secondary" />
					</Button>
				</span>
			),
		},
	];

	const rows = state.vendors.map(
		({ vendorId, vendorName, nsblVendorId, isActive }) => ({
			vendorId,
			vendorName,
			nsblVendorId,
			isActive: isActive ? "Active" : "Inactive",
		}),
	);

	return { rows, columns };
};
